import React, { useEffect, useState } from "react";

export default function useDropdown(dropDownRef) {
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (dropDownRef.current && !dropDownRef.current?.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return {
    dropdownOpen,
    setDropdownOpen,
  };
}
